export const removeWhitespace = (input: string) => input.replace(/\s+/g, "");
